module.exports = __webpack_public_path__ + "img/omg_cartel.88025e5b.jpg";